import { useEffect, useState } from "react";
import { api } from "./api";
import type { StoryPreviewData } from "../types";

const previews = new Map<string, { data: StoryPreviewData; at: number }>();
const pending = new Map<string, Promise<StoryPreviewData>>();
export function loadStoryPreview(id: string): Promise<StoryPreviewData> {
  const cached = previews.get(id);
  if (cached && Date.now() - cached.at < 60_000) return Promise.resolve(cached.data);
  const existing = pending.get(id);
  if (existing) return existing;
  const request = api<StoryPreviewData>(`/api/feed/${encodeURIComponent(id)}/preview`).then(data => {
    previews.delete(id);
    previews.set(id, { data, at: Date.now() });
    if (previews.size > 40) previews.delete(previews.keys().next().value!);
    return data;
  }).finally(() => pending.delete(id));
  pending.set(id, request);
  return request;
}

export function useStoryPreview(id: string, enabled: boolean) {
  const [data, setData] = useState<StoryPreviewData | null>(null);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let alive = true;
    setData(null); setError(false);
    if (enabled) void loadStoryPreview(id).then(result => { if (alive) setData(result); })
      .catch(() => { if (alive) setError(true); });
    return () => { alive = false; };
  }, [id, enabled, attempt]);
  return { data: data?.id === id ? data : null, error, retry: () => setAttempt(value => value + 1) };
}
